import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TemplateCard } from '../components/features/TemplateCard';

const TEMPLATES = [
  {
    id: 'minimal',
    name: 'Minimalist',
    description: 'Clean and simple design focusing on content. Perfect for corporate roles.',
    image: '/templates/minimalist_resume_preview_1769806179059.png'
  },
  {
    id: 'creative',
    name: 'Creative',
    description: 'Bold colors and modern layout. Ideal for designers and marketing pros.',
    image: '/templates/creative_resume_preview_1769806194818.png'
  },
  {
    id: 'executive',
    name: 'Executive',
    description: 'Professional and authoritative. Great for senior positions.',
    image: '/templates/executive_resume_preview_1769806211119.png'
  },
  {
    id: 'modern',
    name: 'Modern',
    description: 'Fresh and teal-accented design for a contemporary look.',
    image: '/templates/modern_resume_preview_1769806226319.png'
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'Serif fonts and subtle layout for a highly polished feel.',
    image: '/templates/professional_resume_preview_1769806241079.png'
  },
  {
    id: 'compact',
    name: 'Compact',
    description: 'Optimized use of space to fit more content on one page.',
    image: '/templates/compact_resume_preview_1769806255757.png'
  },
  {
    id: 'tech',
    name: 'Tech',
    description: 'Dark mode inspired theme for developers and techies.',
    image: '/templates/tech_resume_preview_1769806285604.png'
  },
  {
    id: 'elegant',
    name: 'Elegant',
    description: 'Sophisticated typography and centered layout.',
    image: '/templates/elegant_resume_preview_1769806301490.png'
  },
  {
    id: 'bold',
    name: 'Bold',
    description: 'High contrast and heavy fonts to make a strong statement.',
    image: '/templates/bold_resume_preview_1769806317521.png'
  }
];

export const TemplateSelection = () => {
  const navigate = useNavigate();

  const handleSelect = (templateId) => {
    // Navigate to editor with selected template ID
    navigate(`/editor?template=${templateId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Choose Your Resume Template</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select a design that fits your style. You can switch templates later at any time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {TEMPLATES.map((template) => (
            <TemplateCard
              key={template.id}
              {...template}
              onSelect={handleSelect}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
